// サントリー様専用配送依頼インポートボタンの表示対象拠点コード
// 岡山早島センター専用機能として確定済み(#3462)
export const SUNTORY_DEDICATED_IMPORT_TARGET_DC_CODE = 'konoike-hayashima'
